import { createRef, PureComponent } from 'react';
import styled from 'styled-components';
import InlineImageAttachment from './InlineImageAttachment';
import { jsx as _jsx } from "react/jsx-runtime";
const MAX_IMAGE_WIDTH = 300;
export const FileAttachmentsWrapper = styled.div.withConfig({
  displayName: "InlineImageAttachments__FileAttachmentsWrapper"
})(["cursor:pointer;box-sizing:border-box;width:100%;max-width:", "px;display:block;margin-bottom:16px;margin-top:8px;"], MAX_IMAGE_WIDTH);
class InlineImageAttachments extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      maxWidth: MAX_IMAGE_WIDTH
    };
    this.wrapperRef = /*#__PURE__*/createRef();
  }
  componentDidMount() {
    const current = this.wrapperRef.current;
    if (current && current.offsetWidth && current.offsetWidth !== this.state.maxWidth) {
      this.setState({
        maxWidth: current.offsetWidth
      });
    }
  }
  render() {
    const {
      fileAttachments
    } = this.props;
    return /*#__PURE__*/_jsx(FileAttachmentsWrapper, {
      "data-test-id": "file-attachments-wrapper"
      // TODO: remove cast when on React 19 types (HubSpotEngineering/fefw#73)
      ,
      ref: this.wrapperRef,
      children: fileAttachments.map((fileAttachment, index) => /*#__PURE__*/_jsx(InlineImageAttachment, {
        name: fileAttachment.displayName,
        url: fileAttachment.url,
        width: fileAttachment.width,
        height: fileAttachment.height,
        maxWidth: this.state.maxWidth
      }, `image-${index}`))
    });
  }
}
InlineImageAttachments.displayName = 'InlineImageAttachments';
export default InlineImageAttachments;